import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs";
import { AjaxRequest, AjaxResponse } from "rxjs/ajax";
import { UploadLinkSuccessResponse } from "./api-response/UploadLinkSuccessResponse";
import { getAuthAndDefaultHeaders } from "./apiConsts";
import { OrganizationKeyName } from "../model/Organization";
import _ from "lodash";
import { map, mapTo, switchMap } from "rxjs/operators";

export class ApiUpload {
  constructor(private apiEndpoint: string) {}

  uploadVenueImage(
    token: string,
    organization: OrganizationKeyName,
    file: File,
    venueId: number
  ): Observable<boolean> {
    const ext = _.toLower(file.name.split(".").pop());
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/upload/venue/${venueId}/${ext}`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(
      map<AjaxResponse, UploadLinkSuccessResponse>((x) => x.response),
      switchMap((linkResponse) => {
        const request: AjaxRequest = {
          method: "PUT",
          url: linkResponse.link,
          body: file,
          crossDomain: true,
          headers: { "Content-Type": file.type },
        };

        return ajax(request);
      }),
      map((x: AjaxResponse) => x.status === 200)
    );
  }

  uploadVenueLogoImage(
    token: string,
    organization: OrganizationKeyName,
    file: File,
    venueId: number
  ): Observable<boolean> {
    const ext = _.toLower(file.name.split(".").pop());

    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/upload/venue/logo/${venueId}/${ext}`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(
      map<AjaxResponse, UploadLinkSuccessResponse>((x) => x.response),
      switchMap((linkResponse) => {
        const request: AjaxRequest = {
          method: "PUT",
          url: linkResponse.link,
          body: file,
          crossDomain: true,
          headers: { "Content-Type": file.type },
        };

        return ajax(request);
      }),
      map((x: AjaxResponse) => x.status === 200)
    );
  }

  uploadMemberCardTypeImage(
    token: string,
    organization: OrganizationKeyName,
    file: File,
    memberCardTypeId: string,
    type: "background" | "logo"
  ): Observable<boolean> {
    const ext = _.toLower(file.name.split(".").pop());
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/upload/member-card-types/${memberCardTypeId}/${ext}/${type}`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(
      map<AjaxResponse, UploadLinkSuccessResponse>((x) => x.response),
      switchMap((linkResponse) => {
        const request: AjaxRequest = {
          method: "PUT",
          url: linkResponse.link,
          body: file,
          crossDomain: true,
          headers: { "Content-Type": file.type },
        };

        return ajax(request);
      }),
      map((x: AjaxResponse) => x.status === 200)
    );
  }

  deleteVenueImage(
    token: string,
    organization: OrganizationKeyName,
    venueId: number,
    imageUrl: string
  ): Observable<null> {
    const imageUrlParam = encodeURIComponent(imageUrl);

    return ajax({
      method: "DELETE",
      url: `${this.apiEndpoint}/organizations/${organization}/upload/venue/${venueId}/${imageUrlParam}`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(mapTo(null));
  }

  uploadShopProductImage(
    token: string,
    organization: OrganizationKeyName,
    file: File,
    productId: string
  ): Observable<boolean> {
    const ext = _.toLower(file.name.split(".").pop());
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/upload/shop-product/${productId}/${ext}`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(
      map<AjaxResponse, UploadLinkSuccessResponse>((x) => x.response),
      switchMap((linkResponse) => {
        const request: AjaxRequest = {
          method: "PUT",
          url: linkResponse.link,
          body: file,
          crossDomain: true,
          headers: { "Content-Type": file.type },
        };

        return ajax(request);
      }),
      map((x: AjaxResponse) => x.status === 200)
    );
  }

  uploadNewsImage(
    token: string,
    organization: OrganizationKeyName,
    file: File,
    newsId: string
  ): Observable<boolean> {
    const ext = _.toLower(file.name.split(".").pop());
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/upload/announcement/${newsId}/${ext}`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(
      map<AjaxResponse, UploadLinkSuccessResponse>((x) => x.response),
      switchMap((linkResponse) => {
        const request: AjaxRequest = {
          method: "PUT",
          url: linkResponse.link,
          body: file,
          crossDomain: true,
          headers: { "Content-Type": file.type },
        };

        return ajax(request);
      }),
      map((x: AjaxResponse) => x.status === 200)
    );
  }

  uploadHomepageImage(
    token: string,
    organization: OrganizationKeyName,
    file: File,
    homepageId: string
  ): Observable<boolean> {
    const ext = _.toLower(file.name.split(".").pop());
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/upload/homepage-config/${homepageId}/${ext}`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(
      map<AjaxResponse, UploadLinkSuccessResponse>((x) => x.response),
      switchMap((linkResponse) => {
        const request: AjaxRequest = {
          method: "PUT",
          url: linkResponse.link,
          body: file,
          crossDomain: true,
          headers: { "Content-Type": file.type },
        };

        return ajax(request);
      }),
      map((x: AjaxResponse) => x.status === 200)
    );
  }
}
